<template>
  <div class="flex flex-col lg:flex-row">
    <div class="information">
      <div class="info-wrapper">
        <h3 class="font-bold font-mont mb-6">
          {{ $t("Product Information") }}
        </h3>
        <div class="chars font-fgb">
          <div class="chars-descr flex justify-between">
            <span class="font-fgb">{{ $t("Article number") }} </span>
            <span class="font-fgb">{{ product.sku }}</span>
          </div>
          <div class="chars-descr flex justify-between">
            <span class="font-fgb">{{ $t("EAN code") }} </span>
            <span class="font-fgb">{{ product.barcode }}</span>
          </div>
          <div
            v-for="item in productInformation"
            :key="item.id"
            class="chars-descr flex"
          >
            <span class="font-fgb">{{ item.label }}</span>
            <div
              v-for="element in item.options"
              :key="element.id"
              class="text-right"
            >
              <span class="font-fgb">{{ element.label }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-11 mb-11 lg:mb-0 info-wrapper">
        <h3 class="font-bold font-mont mb-6">{{ $t("Dimensions") }}</h3>
        <div class="chars font-fgb">
          <div
            class="chars-descr flex justify-between"
            v-if="
              product.package_width &&
              product.package_length &&
              product.package_depth
            "
          >
            <span>{{ $t("package dimensions") }} </span>
            <span
              >{{ parseFloat(product.package_width).toFixed(2) }} x
              {{ parseFloat(product.package_length).toFixed(2) }} x
              {{ parseFloat(product.package_depth).toFixed(2) }} cm</span
            >
          </div>
          <div
            class="chars-descr flex justify-between"
            v-if="
              product.product_height &&
              product.product_length &&
              product.product_width
            "
          >
            <span>{{ $t("product dimensions") }} </span>
            <span
              >{{ parseFloat(product.product_height).toFixed(2) }} x
              {{ parseFloat(product.product_length).toFixed(2) }} x
              {{ parseFloat(product.product_width).toFixed(2) }} cm</span
            >
          </div>
          <div
            class="chars-descr flex justify-between"
            v-if="product.product_weight_kg"
          >
            <span>{{ $t("product weight") }} </span>
            <span
              >{{
                parseFloat(product.product_weight_kg).toFixed(2)
              }}
              grams</span
            >
          </div>
          <div
            class="chars-descr flex justify-between"
            v-if="product.product_diameter"
          >
            <span>{{ $t("product diameter") }} </span>
            <span
              >{{ parseFloat(product.product_diameter).toFixed(2) }} cm</span
            >
          </div>
          <div
            class="chars-descr flex justify-between"
            v-if="product.insertable_length"
          >
            <span>{{ $t("insertable length") }} </span>
            <span
              >{{ parseFloat(product.insertable_length).toFixed(2) }} cm</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="chars-wrapper">
      <h3 class="font-bold font-mont mb-6">{{ $t("Characteristics") }}</h3>
      <div>
        <div class="chars">
          <div
            v-for="item in characteristics"
            :key="item.id"
            class="chars-items"
          >
            <div class="chars-descr flex">
              <span class="font-fgb"> {{ $t(item.label) }} </span>
              <div class="chars-value flex">
                <div v-for="label in item.options" :key="label.id">
                  <span class="font-fgb align-left">{{ $t(label.label) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="chars-descr chars-items flex font-fgb"
            v-if="product.batteries_quantity"
          >
            <span>{{ $t("batteries quantity") }} </span>
            <span>{{ product.batteries_quantity }}</span>
          </div>
          <div
            class="chars-descr chars-items flex font-fgb"
            v-if="product.batteries_included"
          >
            <span>{{ $t("batteries included") }} </span>
            <span v-if="product.batteries_included == 1">
              {{ $t("yes") }}
            </span>
            <span v-else> {{ $t("no") }}</span>
          </div>
          <div
            class="chars-descr chars-items flex font-fgb"
            v-if="product.battery_lifetime"
          >
            <span>{{ $t("battery lifetime") }} </span>
            <span>{{ product.battery_lifetime }} min</span>
          </div>
          <div
            class="chars-descr chars-items flex font-fgb"
            v-if="product.time_to_recharge"
          >
            <span>{{ $t("time to recharge") }} </span>
            <span>{{ product.time_to_recharge }} min</span>
          </div>
          <div
            class="chars-descr chars-items flex font-fgb"
            v-if="product.phthalate_free"
          >
            <span> {{ $t("phthalate free") }} </span>
            <span v-if="product.phthalate_free == 1">{{ $t("yes") }}</span>
            <span v-else>{{ $t("no") }}</span>
          </div>
          <div class="chars-descr chars-items flex font-fgb" v-if="product.rpm">
            <span>{{ $t("RPM") }} </span>
            <span>{{ product.rpm }}</span>
          </div>
          <div
            class="chars-descr chars-items flex font-fgb"
            v-if="product.noise_level_db"
          >
            <span>{{ $t("noise level") }} </span>
            <span>{{ product.noise_level_db }} DB</span>
          </div>
          <div
            class="chars-descr chars-items flex font-fgb"
            v-if="product.textile_composition"
          >
            <span>{{ $t("textile composition") }} </span>
            <span>{{ product.textile_composition }}</span>
          </div>
          <div
            class="chars-descr chars-items flex font-fgb"
            v-if="product.product_volume"
          >
            <span>{{ $t("product volume") }} </span>
            <span>{{ product.product_volume }}</span>
          </div>
          <div
            class="chars-descr chars-items flex font-fgb"
            v-if="product.inner_diameter"
          >
            <span>{{ $t("inner diameter") }} </span>
            <span>{{ product.inner_diameter }}</span>
          </div>
          <div class="chars-descr chars-items flex font-fgb">
            <span>{{ $t("lithium inside") }} </span>
            <span v-if="product.lithium_inside == 1">{{ $t("yes") }}</span>
            <span v-else>{{ $t("no") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from "@nuxtjs/composition-api";
export default {
  name: "ProductSpecifications",
  props: {
    product: {
      type: Object,
      required: false,
      default: {},
    },
  },
  setup(props) {
    const dimensionsInformation = ref([]);

    const productInformation = ref([]);

    const characteristics = ref([]);

    const getProductInformation = () => {
      const remainingAggregations = [];

      props.product.aggregations.forEach((item) => {
        if (
          item.attribute_code == "color" ||
          item.attribute_code == "brand" ||
          item.attribute_code == "sub_brand"
        ) {
          productInformation.value.push(item);
        } else if (
          item.attribute_code == "product_length_range" ||
          item.attribute_code == "product_diameter_range" ||
          item.attribute_code == "insertable_length_range" ||
          item.attribute_code == "product_length" ||
          item.attribute_code == "product_width"
        ) {
          dimensionsInformation.value.push(item);
        } else if (item.attribute_code == "Insertable Length (cm)") {
          dimensionsInformation.value.push(item);
        } else if (
          item.attribute_code == "category_uid" ||
          item.attribute_code == "price" ||
          item.attribute_code == "product_diameter_inch_range" ||
          item.attribute_code == "product_length_inch_range" ||
          item.attribute_code == "insertable_length_inch_range"
        ) {
          return false;
        } else if (
          item.attribute_code == "batteries_type" ||
          item.attribute_code == "product_taste" ||
          item.attribute_code == "rechargeable" ||
          item.attribute_code == "waterproof" ||
          item.attribute_code == "splashproof" ||
          item.attribute_code == "materials" ||
          item.attribute_code == "quantity_motors" ||
          item.attribute_code == "speed_modes" ||
          item.attribute_code == "batteries_required" ||
          item.attribute_code == "device_control" ||
          item.attribute_code == "product_fragrance" ||
          item.attribute_code == "amount_of_vibration_patterns" ||
          item.attribute_code == "product_size"
        ) {
          remainingAggregations.push(item);
        }
      });

      characteristics.value = remainingAggregations;
    };

    onMounted(() => {
      getProductInformation();
    });

    return { productInformation, dimensionsInformation, characteristics };
  },
};
</script>
<style lang="scss" scoped>
.information {
  width: fit-content;
  margin-right: 60px;
  @media only screen and (max-width: 480px) {
    margin-right: 0;
  }
  .info-wrapper {
    .chars {
      .chars-descr {
        max-width: 380px;
        margin: 5px 0;
        padding: 0 15px;
        justify-content: space-between;
        &:nth-child(odd) {
          background-color: #fbfbfb;
        }
      }
    }
  }
}
.info-wrapper {
  .chars-descr {
    width: 380px;
    @media only screen and (max-width: 1023px) {
      width: 100%;
    }
  }
  font-weight: 500;
}
.chars-wrapper {
  .chars {
    @media only screen and (max-width: 480px) {
      display: flex;
      flex-direction: column;
    }
    @media only screen and (max-width: 768px) {
      grid-template-columns: repeat(auto-fill, 290px);
    }
    display: grid;
    grid-template-rows: repeat(12, auto);
    grid-template-columns: repeat(auto-fill, 370px);
    column-gap: 1em;
    grid-auto-flow: column;
    gap: 10px;
    .chars-items {
      width: 360px;
      &:nth-child(odd) {
        background-color: #fbfbfb;
      }
      @media only screen and (max-width: 1023px) {
        width: 100%;
      }
    }
    grid-row: span 2;
    .chars-descr {
      justify-content: space-between;
      padding: 0 15px;
      font-weight: 500;
    }
    .chars-value {
      gap: 10px;
    }
  }
}
.chars-descr {
  width: 360px;
  span {
    &::first-letter {
      text-transform: capitalize;
    }
  }
  @media only screen and (max-width: 1023px) {
    width: 100%;
  }
  /* &:nth-child(odd) {
    background-color: #fbfbfb;
  } */
}
</style>
